export const MAX_DB_INTEGER = 2147483648;
